import { ref, resolveComponent, createBlock, openBlock, unref, withCtx, createVNode, createTextVNode, toDisplayString, mergeProps, createElementVNode } from "vue";
import { PUBLIC_ARTICLES, DELETE_PUBLIC_ARTICLE } from "../../graphql/public-articles.js";
import { useApolloGlobalClient } from "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useBanza } from "../../plugins/banza/global.js";
import "axios";
import { useRouter } from "../../plugins/router.js";
import { useI18n } from "../../plugins/i18n.js";
import "maska";
import { useLocalePath } from "../../composables/useLocalePath.js";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vue-router";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import { VList, VListItem, VListItemTitle } from "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import { VBtn } from "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import { VMenu } from "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import { VHover } from "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
/* empty css                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _hoisted_1 = ["onClick"];
const _sfc_main = {
  __name: "PublicArticlesSection",
  setup(__props) {
    const { t } = useI18n();
    const banza = useBanza();
    const client = useApolloGlobalClient();
    const router = useRouter();
    const localePath = useLocalePath();
    const section = ref(null);
    const headers = ref([
      { title: t("base.labels.name"), key: "title" },
      { title: t("base.labels.code"), key: "code" },
      { title: t("base.labels.createdOn"), key: "createdOn" },
      { title: t("base.labels.modifiedOn"), key: "modifiedOn" },
      { title: t("base.buttons.actions"), key: "actions", sortable: false }
    ]);
    const createItem = () => {
      router.push(localePath("/admin/articles/add/new"));
    };
    const editItem = (item) => {
      router.push(localePath("/admin/articles/" + item.code));
    };
    const deleteItem = async (item) => {
      const { isConfirmed } = await banza.showGlobalMessage({
        text: t("base.messages.ask_to_delete"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: t("base.buttons.yes"),
        cancelButtonText: t("base.buttons.cancel")
      });
      if (!isConfirmed) {
        return;
      }
      await client.mutate({
        mutation: DELETE_PUBLIC_ARTICLE,
        variables: {
          code: item.code
        }
      });
      reload();
    };
    const reload = () => {
      var _a;
      return (_a = section.value) == null ? void 0 : _a.reload();
    };
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_section = resolveComponent("b-section");
      return openBlock(), createBlock(_component_b_section, {
        ref_key: "section",
        ref: section,
        header: _ctx.$t("components.admin.public_articles.PublicArticlesSection.header"),
        headers: unref(headers),
        query: unref(PUBLIC_ARTICLES),
        searchPlaceholder: _ctx.$t("base.buttons.search"),
        searchField: "title,code"
      }, {
        "header-actions": withCtx(() => [
          createVNode(_component_b_btn, {
            preset: "add",
            onClick: createItem
          })
        ]),
        "item.title": withCtx(({ item }) => [
          createVNode(VHover, null, {
            default: withCtx(({ isHovering, props }) => [
              createElementVNode("span", mergeProps({
                class: [
                  "c-pointer",
                  isHovering ? "text-decoration-underline" : ""
                ],
                onClick: ($event) => _ctx.$router.push(unref(localePath)(`/article/${item.code}`))
              }, props), toDisplayString(item.title), 17, _hoisted_1)
            ]),
            _: 2
          }, 1024)
        ]),
        "item.createdOn": withCtx(({ item }) => {
          var _a, _b;
          return [
            createTextVNode(toDisplayString(_ctx.$moment(item.createdOn).format("lll") + (((_a = item.createdBy) == null ? void 0 : _a.name) ? ` - ${(_b = item.createdBy) == null ? void 0 : _b.name}` : "")), 1)
          ];
        }),
        "item.modifiedOn": withCtx(({ item }) => {
          var _a, _b;
          return [
            createTextVNode(toDisplayString(_ctx.$moment(item.modifiedOn).format("lll") + (((_a = item.modifiedBy) == null ? void 0 : _a.name) ? ` - ${(_b = item.modifiedBy) == null ? void 0 : _b.name}` : "")), 1)
          ];
        }),
        "item.actions": withCtx(({ item }) => [
          createVNode(VMenu, null, {
            activator: withCtx(({ props }) => [
              createVNode(VBtn, mergeProps(props, {
                icon: "mdi-dots-vertical",
                variant: "text",
                size: "small"
              }), null, 16)
            ]),
            default: withCtx(() => [
              createVNode(VList, { density: "compact" }, {
                default: withCtx(() => [
                  createVNode(VListItem, {
                    onClick: ($event) => editItem(item)
                  }, {
                    append: withCtx(() => [
                      createVNode(_component_b_icon, {
                        icon: "mdi-pencil",
                        size: "28",
                        color: "text"
                      })
                    ]),
                    default: withCtx(() => [
                      createVNode(VListItemTitle, null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.$t("base.buttons.edit")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  createVNode(VListItem, {
                    onClick: ($event) => deleteItem(item)
                  }, {
                    append: withCtx(() => [
                      createVNode(_component_b_icon, {
                        icon: "mdi-delete",
                        size: "28",
                        color: "text"
                      })
                    ]),
                    default: withCtx(() => [
                      createVNode(VListItemTitle, null, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(_ctx.$t("base.buttons.delete")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["header", "headers", "query", "searchPlaceholder"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
